module.exports = __webpack_public_path__ + "files/4c3f1c234376539f4fdd4fa0e1e4722d.png";